const buttons = [
    { label: '7', type: 'number' },
    { label: '8', type: 'number' },
    { label: '9', type: 'number' },
    { label: 'backspace', type: 'action' },
    { label: '4', type: 'number' },
    { label: '5', type: 'number' },
    { label: '6', type: 'number' },
    { label: '*', type: 'operator' },
    { label: '1', type: 'number' },
    { label: '2', type: 'number' },
    { label: '3', type: 'number' },
    { label: '-', type: 'operator' },
    { label: '0', type: 'number' },
    { label: '.', type: 'number' },
    { label: '=', type: 'action' },
    { label: '+', type: 'operator' },
    { label: 'Clear', type: 'action'},
    { label: '/', type: 'operator' }
  ];
  
  export default buttons;
  